import { App, type URLOpenListenerEvent } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';
import { useNavigate } from '@tanstack/react-router';
import { memo, useEffect } from 'react';

import { isNativePlatform } from '@/shared/utils/platform';

export const DeepLinkHandler = memo(() => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) {
      return;
    }

    let listener: PluginListenerHandle | undefined;

    const handleDeepLink = async (event: URLOpenListenerEvent) => {
      try {
        const url = new URL(event.url);
        const path = url.pathname || '/';
        if (path === '/oauth/callback') {
          return;
        }

        const search = url.search || '';

        await navigate({ to: path + search });
      } catch {
        /* empty */
      }
    };

    void App.addListener('appUrlOpen', handleDeepLink).then(result => {
      listener = result;
    });

    return () => {
      void listener?.remove();
    };
  }, [navigate]);

  return null;
});
